import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslate } from 'react-admin';

const ExportInterventionHeader = () => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'grid',
                justifyContent: 'center',
                justifyItems: 'center',
                gap: 1,
            }}
        >
            <Box
                sx={{
                    height: 45,
                }}
                component='img'
                src={'/images/big-logo-white.png'}
                alt={'mainLogo'}
            />

            <Typography
                variant='h4'
                sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    letterSpacing: '0.3px',
                }}
            >
                {translate('intervention.export.title')}
            </Typography>

            <Typography
                variant='body1'
                color='text.secondary'
                sx={{
                    fontSize: '0.95rem',
                }}
            >
                {translate('intervention.export.subtitle')}
            </Typography>
        </Box>
    );
};

export default ExportInterventionHeader;

